import { InventoryReturnFormData, InventoryReturnRow } from './types';

export const returnStatusOptions = [
  { id: 'all', name: 'Tất cả' },
  { id: 'draft', name: 'Nháp' },
  { id: 'approved', name: 'Đã duyệt' },
  { id: 'posted', name: 'Đã ghi sổ' },
  { id: 'inactive', name: 'Ngưng dùng' },
];

export const inventoryReturnRows: InventoryReturnRow[] = [];

export const createDefaultReturnForm = (companyId: string): InventoryReturnFormData => ({
  code: '',
  name: '',
  order_no: '',
  store_name: '',
  status: 'draft',
  qty: '',
  company_id: companyId,
  note: '',
});
